export default function Facial() {
  const procedures = [
    { name: "Skinbooster", icon: "ri-drop-line" },
    { name: "Bioestimulador de colágeno facial", icon: "ri-leaf-line" },
    { name: "Preenchimento labial", icon: "ri-heart-line" },
    { name: "Rinomodelação", icon: "ri-focus-line" },
    { name: "Preenchimento de mento", icon: "ri-user-smile-line" },
    { name: "Marcação mandibular", icon: "ri-bar-chart-grouped-line" },
    { name: "Preenchimento de malar", icon: "ri-sun-line" },
    { name: "Preenchimento de bigode chinês", icon: "ri-bubble-chart-line" },
    { name: "Preenchimento full face", icon: "ri-landscape-line" },
    { name: "Lipólise de papada", icon: "ri-scissors-line" },
    { name: "Blefaroplastia", icon: "ri-eye-line" },
    { name: "Laser de CO2", icon: "ri-sparkling-line" }
  ];

  return (
    <section id="facial" className="bg-[#faf8f5] py-16 px-5 sm:px-8 lg:px-16">
      <div className="max-w-5xl mx-auto">

        {/* Header — discreto */}
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <div className="w-8 h-px bg-[#C9A84C]/60"></div>
              <span className="text-[#C9A84C]/80 text-xs tracking-[0.25em] uppercase font-semibold" style={{ fontFamily: 'DM Sans, sans-serif' }}>
                Também realizamos
              </span>
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold text-[#1a1a1a] leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Procedimentos <span className="italic text-[#C9A84C]">Faciais</span>
            </h2>
          </div>
          <p className="text-[#999] text-xs leading-relaxed max-w-xs text-right hidden sm:block" style={{ fontFamily: 'DM Sans, sans-serif' }}>
            Complementando a excelência corporal com harmonização facial de alta precisão.
          </p>
        </div>

        <p className="text-[#888] text-sm leading-relaxed mb-8 max-w-2xl sm:hidden" style={{ fontFamily: 'DM Sans, sans-serif' }}>
          Complementando a excelência corporal com harmonização facial de alta precisão.
        </p>

        {/* Procedures grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2.5">
          {procedures.map((proc) => (
            <div
              key={proc.name}
              className="flex items-center gap-3 bg-white border border-[#e8dfc8] rounded-xl px-4 py-3.5 hover:border-[#C9A84C]/50 hover:bg-[#fdf9f0] transition-all duration-300 group cursor-default"
            >
              <div className="w-7 h-7 flex items-center justify-center flex-shrink-0">
                <i className={`${proc.icon} text-[#C9A84C]/70 text-sm group-hover:text-[#C9A84C] transition-colors duration-300`}></i>
              </div>
              <span className="text-[#555] text-xs leading-tight font-medium" style={{ fontFamily: 'DM Sans, sans-serif' }}>{proc.name}</span>
            </div>
          ))}
        </div>

        {/* Subtle note */}
        <div className="flex items-center gap-2 mt-6">
          <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
            <i className="ri-information-line text-[#C9A84C]/60 text-sm"></i>
          </div>
          <p className="text-[#bbb] text-xs" style={{ fontFamily: 'DM Sans, sans-serif' }}>
            Procedimentos realizados com técnica refinada, priorizando naturalidade, equilíbrio e resultados harmoniosos.
          </p>
        </div>
      </div>
    </section>
  );
}
